var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{class:_vm.$style.home},[_c('img',{class:_vm.$style.logo,attrs:{"src":(_vm.publicPath + "rappilogoorange.png"),"alt":"Rappi"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }